const Config = {
    SPOTIFY_BASE_URL: 'https://api.spotify.com/v1',
    SPOTIFY_SCOPE: 'playlist-modify-private',
}

export default Config;